<script setup lang="ts">
import type { SaleItemEntity } from '~/types/sale.type';

// PROPS
const { sale } = defineProps({
    sale: { type: Object as PropType<SaleItemEntity>, required: true },
});

// COMPOSABLES
const { isMonoVersion } = useSaleType(() => sale.type);
</script>

<template>
    <template v-if="isMonoVersion">
        <SdpSpecs :sale="sale" />
        <MktgTrustReport />
        <SdpDetails :sale="sale" />
    </template>

    <SdpMultiGrid v-else :sale="sale" />
</template>
